module.exports = __webpack_public_path__ + "static/media/dot_F50D0D.7bc58f31.svg";